import LogManager from "./LogManager";

/**
 * Utility function to call the rtms-status-update API
 * @param {string} action - The action to perform ("start", "stop", "started")
 * @param {string} meetingUuid - The meeting UUID
 * @param {string} meetingId - The meeting ID
 * @param {string} role - The user role
 * @param {string} appContext - The app context JWT string from Zoom SDK for secure backend validation
 * @returns {Promise<Object>} The parsed response from the API
 */
export const fetchRtmsStatusUpdate = async (action, meetingUuid, meetingId, role, appContext) => {
  try {
    const data = {
      action,
      role,
      meetingUuid,
      meetingId,
      requestId: crypto.randomUUID(),
      context: appContext,
    };
    
    LogManager.info(`Calling /rtms-status-update with action "${action}". Request body is: ${JSON.stringify(data)}`);

    const response = await fetch("/rtms-status-update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const responseJson = await response.json();
    LogManager.info(`The responseJson of /rtms-status-update (${action}) is: `, responseJson);

    let parsedPayload = JSON.parse(responseJson.Payload);
    LogManager.info(`Parsed RtmsResponse payload from ${action} result is:`, parsedPayload);

    const rtmsResponse = JSON.parse(parsedPayload);
    
    if (rtmsResponse.result === "OK") {
      LogManager.info(`RTMS status update (${action}) successful`);
    } else {
      LogManager.warn(`RTMS status update (${action}) returned non-OK result:`, rtmsResponse.result);
    }
    
    return rtmsResponse;
  } catch (error) {
    LogManager.error(`Error calling /rtms-status-update with ${action} action:`, error);
    throw error;
  }
};
